import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/product/integrations/page.tsx");
